import { Card, CardContent, LinearProgress, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Autocomplete } from '@material-ui/lab';
import React, { useEffect, useState } from 'react';
import Strapi from '../../services/strapi';

interface SelectArticleProps {
  label: string,
  strapiContent: string
  default?: any,
  onChange?: Function,
  loading?: boolean
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  title: {
    fontWeight: 'bold'
  },
  autocomplete: {
    marginTop: '1vh'
  }
}));

const SelectArticle = (props: SelectArticleProps) => {
  const classes = useStyles();
  const [loading, setLoading] = useState<boolean>(false);
  const [options, setOptions] = useState<any[]>([]);
  const [article, setArticle] = useState<any | null>(null)
  const [inputText, setInputText] = useState<{value: string, reason: string}>({value: '', reason: ''});

  useEffect(() => {
    if (props.loading !== undefined)
      setLoading(props.loading);
  }, [props.loading]);

  useEffect(() => {
    const after = new Date();
    after.setMonth(after.getMonth() - 1);
    if (inputText.value === '' || inputText.reason === 'reset') {
      setOptions([]);
      setLoading(false);
      return
    }
    setLoading(true);
    let active = true;
    let params: any = {};
    if (props.strapiContent === 'all') {
      params = {
        _limit: 5,
        search: inputText.value
      };
    } else {
      params = {
        _limit: 5,
        title_contains: inputText.value
      }
    }
	  Strapi.get(props.strapiContent, params, {}).then((r) => {
			if (active) {
        setLoading(false);
        setOptions(r);
			}
		});
    return () => {
			active = false;
		}
  }, [inputText]);

  useEffect(() => {
    if (props.default && props.default.data) {
      if (props.onChange)
        props.onChange(props.default);
      setArticle(props.default);
    }
  }, [props.default]);

  return (
    <Card>
      <CardContent>
        <div className={classes.title}>{props.label}</div>
        <div className={classes.autocomplete}>
          {loading && <LinearProgress style={{margin: '0.5vh'}}/>}
          <Autocomplete
            loadingText="Chargement en cours ..."
            noOptionsText="Aucun article trouvé"
            style={{display: 'flex', flex: 1}}
            loading={loading}
            value={article}
            options={options}
            inputValue={inputText.value}
            onInputChange={(_, newValue, reason) => {
              setInputText({value: newValue, reason});
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                variant="outlined"
                label="Titre"
                required
              />
            )}
            getOptionLabel={(option) => option.title || option.data.title || ""}
            getOptionSelected={(option, val) => option.data.title === val.data.title}
            onChange={(e, changedValue) => {
              if (props.onChange)
                props.onChange(changedValue);
              setArticle(changedValue);
            }}
          />
        </div>
      </CardContent>
    </Card>
  );
}

export default SelectArticle;